import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const blockImages = () => {
  const images = document.querySelectorAll(".blocks figure");

  if (!images.length) return;

  images.forEach((image) => {
    gsap.fromTo(
      image,
      {
        opacity: 0,
        y: 40,
      },
      {
        opacity: 1,
        y: 0,
        scrollTrigger: {
          trigger: image,
          start: "top 80%",
          end: "bottom 80%",
          scrub: true,
          duration: 0.5,
        },
      }
    );
  });
};

// For figures in entries
if (document.querySelector(".entry")) {
  blockImages();
}
